import { makeStyles } from '@material-ui/styles';
import { ShopwareUuid } from '@services/types/Shopware';
import useUserStore, { TrackedWishlistItem } from '@services/stores/UserStore';
import { useTranslation } from '@tools/i18n';
import Link from 'next/link';
import { CSSProperties, useEffect, useState } from 'react';

const useStyles = makeStyles({
    label: {
        display: 'flex',
        gap: 8,
        background: '#f0f0f0',
        padding: '6px 10px',
        width: 'fit-content',
        fontSize: 11,
        '& a': {
            fontWeight: 600,
            textDecoration: 'none',
            color: 'inherit',
            opacity: 0.9,
            '&:hover': {
                opacity: 0.7,
            },
        },
    },
}, { name: 'account-label' });

type WishlistCartItemProps = {
    productId: ShopwareUuid;
    style?: CSSProperties;
}
export const WishlistCartItem = ({ productId, style }: WishlistCartItemProps) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const wishlistMethods = useUserStore((state) => state.wishlistMethods);
    const trackedItems = useUserStore(state => state.trackedCartWishlistProducts);
    const [ trackedItem, setTrackedItem ] = useState<TrackedWishlistItem|null>(null);

    useEffect(() => {
        setTrackedItem(wishlistMethods.getTrackedItem(productId as string));
    }, [ trackedItems.length ]);

    if (!trackedItem) {
        return <></>;
    }

    return <div style={style} className={classes.label}>
        <span>
            {t('account:added-from-wishlist')}
            <Link href={`${wishlistMethods.getSharedUrl(trackedItem.wishlistUuid)}#${productId}`}>
                <a>
                    {trackedItem.wishlistName}
                </a>
            </Link>
        </span>
    </div>;
};
